export const WEEKLY_STATUS = {
  id: 'demo-skl-weekly-status',
  title: 'Weekly status write-up',
  description:
    'Turns a week of merged PRs, Notion updates, and Slack threads into a status update people actually read.',
  apps: ['GitHub', 'Notion', 'Slack'],
  usedCount: 9,
  lastUsedMinutesAgo: 6 * 24 * 60 + 45,
  instructions: `**Write this week's status update:**

1. Collect pull requests merged in the last 7 days and group them by project.
2. Read Notion pages edited this week in the Projects database for decisions and risks.
3. Skim #eng and #product for anything blocked or escalated.
4. Write three sections: **Shipped**, **In progress**, **Risks and asks**.
5. Keep each bullet to one line and link the PR or page it came from.

**Tone:** plain and specific. No "great progress" — say what changed for users.`,
  examples: ['Write this week’s status update', 'Draft the status update for the data platform team'],
}
